import { ErrorIcon, ExpiredIcon, WrongLinkIcon } from 'img';
import React from 'react';
import styled from 'styled-components';

import { ApiError, ErrorTypes } from '../../api/error';

interface ErrorIconRendererProps {
    error?: ApiError | null | string;
    isExpired: boolean;
}

const ErrorIconRenderer = ({ error, isExpired }: ErrorIconRendererProps) => {
    const errorCode = typeof error === 'string' ? error : error?.errorCode;

    if (errorCode === ErrorTypes.Connection || errorCode === ErrorTypes.Timeout) {
        return (
            <Icon>
                <ErrorIcon />
            </Icon>
        );
    }

    if (isExpired) {
        return <ExpiredIcon />;
    }

    return (
        <Icon>
            <WrongLinkIcon />
        </Icon>
    );
};

export default ErrorIconRenderer;

const Icon = styled.div`
    align-items: center;
    background-color: ${ ({ theme }) => theme.semanticColor.uiBackground };
    border-radius: 50%;
    display: flex;
    height: 60px;
    justify-content: center;
    margin: 0 auto 20px;
    width: 60px;
`;
